$(document).ready(function() {
  $('header .search-bar-open').click(function(){
    $('header .header__search-bar-wrapper ').show(500);
  });
  $('header .search-bar-close').click(function(){
    $('header .header__search-bar-wrapper ').hide(500);
  });

  //FAQs section
  $('.pdp__faq .pdp-question').click(function(){
    $('.pdp__faq .pdp-question').removeClass('is-open');
    $(this).addClass('is-open');
  })


 // on scroll add class on header
  window.addEventListener('scroll', function () {
  const elements = document.querySelectorAll('.header.header--inline, .nav-bar');
  elements.forEach(function (element) {
    if (window.scrollY > 500) {
      element.classList.add('sticky--header');
    } else {
      element.classList.remove('sticky--header');
    }
  });
    
});
  
  const targetElement = document.querySelector('.product-block-list__item--content');
  let hasClassBeenAdded = false;  // To track if the class has been added
  let lastScrollTop = 0;  // To track the scroll position for scroll direction

  // Callback function to execute when the element is in view
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // When the element enters the viewport, add the class if it's not already added
        if (!hasClassBeenAdded) {
          document.body.classList.add('element-in-view');
          hasClassBeenAdded = true;  // Mark that the class has been added
        }
      } else {
        // If the element is out of the viewport and scrolling up, remove the class
        if (window.pageYOffset < lastScrollTop) {
          document.body.classList.remove('element-in-view');
          hasClassBeenAdded = false;  // Reset the flag to allow re-adding later
        }
      }
    });
  };

  // Create an IntersectionObserver instance
  const observer = new IntersectionObserver(callback, {
    root: null,  // Use the viewport as the root
    threshold: 0.5,  // Trigger when 50% of the element is in view
  });

  // Start observing the target element
  observer.observe(targetElement);

  // Listen to scroll event to track scroll direction (up or down)
  window.addEventListener('scroll', () => {
    lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;  // Update scroll position
  });

$('.template-product .block-swatch__item').click(function(){
    setTimeout(function(){
      var priceHTML = $('.template-product .price-list .price.price--highlight').html();
    $('.template-product .product-form__payment-container .mobile-product-price').html(priceHTML);
    }, 500);
})

 





  
});
